function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#AEFF00;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{fill:#16161A;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M38.8,52.3H48v-24c0-3.1-2.5-5.5-5.5-5.5H5.5c-3.1,0-5.5,2.5-5.5,5.5v24h9.2c1,0,1.8,0.8,1.8,1.8 c0,1-0.8,1.8-1.8,1.8H0v2.5C0,61.5,2.5,64,5.5,64h36.9c3.1,0,5.5-2.5,5.5-5.5V56h-9.2c-1,0-1.8-0.8-1.8-1.8 C36.9,53.1,37.7,52.3,38.8,52.3z M2.5,41.1c0,0.9-0.3,1.6-0.7,2.3c0.4,0.7,0.7,1.5,0.7,2.3v1.2C2.5,49.1,21.5,57,23,58l-2-3.8 l3.4,1.8c0,1,0.6-1.5-0.4-1.5s-1.8-0.8-1.8-1.8V51h-2.8c-1,0-1.8-0.8-1.8-1.8v-5.8v-5.8c0-1,0.8-1.8,1.8-1.8h2.8v-1.6 c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8v1.6l3.2-2.3c2.3,0-7.5-8-26.5,6.4V41.1z"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  x: 14,
  y: 31,
  width: 20,
  height: 25
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "st1"
}, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M31.6,37.7c-0.1-1-0.3-1.8-0.8-2.7c-1.3-2.3-3.3-3.7-5.8-4c-1.4-0.2-2.9,0-4.2,0.6c-2.1,1-3.5,2.6-4.1,4.9 c-0.1,0.4-0.2,0.8-0.3,1.3c0,0-0.1,0-0.1,0c-0.4-0.2-0.9-0.2-1.3-0.1c-0.5,0.1-1,0.6-0.9,1.1c0,0.3,0.1,0.6,0.3,0.9 c0.1,0.2,0.2,0.4,0.4,0.6c0.5,0.7,0.9,1.3,1.4,2c0.2,0.3,0.3,0.5,0.3,0.9c0,0.6,0,1.2-0.1,1.7c-0.1,0.8,0,1.6,0.1,2.4 c0.1,0.9,0.5,1.7,0.9,2.5c0,0,0,0.1,0.1,0.1c0.1,0.1,0.2,0.1,0.2,0c0.1-0.1,0.1-0.2,0.2-0.4c0.1-0.2,0.3-0.2,0.5,0 c0.1,0.1,0.2,0.3,0.3,0.5c0.1,0.3,0.2,0.6,0.4,1c0.1,0.2,0.2,0.4,0.3,0.7c0.1-0.1,0.2-0.2,0.4-0.3c0.2-0.2,0.5-0.1,0.6,0.1 c0.1,0.1,0.1,0.3,0.2,0.4c0.2,0.5,0.4,1,0.6,1.4c0.1,0.3,0.3,0.6,0.5,0.9l0.1,0c0-0.1,0-0.2,0-0.2c0.1-0.3,0.1-0.5,0.2-0.8 c0.3-0.5,0.8-0.6,1.2-0.2c0.2,0.2,0.3,0.5,0.5,0.8c0.3,0.6,0.4,1.3,0.5,2c0,0.1,0,0.2,0.1,0.3l0.1,0c0-0.1,0.1-0.2,0.1-0.3 c0.3-0.5,0.5-1.1,0.8-1.6c0.2-0.3,0.4-0.4,0.8-0.4c0.1,0,0.2,0.1,0.3,0.1c0.2-0.6,0.5-1.1,0.9-1.5c0.3-0.3,0.6-0.3,0.8,0.1 c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.1,0.1,0.2c0.1-0.3,0.2-0.5,0.3-0.8c0.1-0.3,0.2-0.7,0.3-1c0.2-0.6,0.3-1.1,0.6-1.6 c0.2-0.2,0.5-0.3,0.6,0c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.2,0.3,0.3,0.5c0,0,0.1-0.1,0.1-0.1c0.7-1.1,1.1-2.3,1.1-3.6 c0-1,0-2.1,0-3.1c0-0.6,0.1-1.1,0.5-1.5c0.5-0.7,1-1.4,1.5-2.1c0.2-0.3,0.3-0.6,0.4-0.9c0.2-0.6,0-1-0.6-1.2 c-0.2-0.1-0.4-0.1-0.6-0.1C32.4,37.7,32,37.7,31.6,37.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M27.1,38.9c1,0,1.6-0.7,1.4-1.7c-0.1-0.3-0.2-0.4-0.5-0.4c-0.4,0.2-0.9,0.3-1.3,0.5c-0.1,0-0.2,0.1-0.3,0.2 c-0.2,0.3-0.2,0.6-0.1,0.9c0.1,0.3,0.4,0.3,0.6,0.3C27,38.9,27.1,38.9,27.1,38.9z M20.8,38.9c0.1,0,0.2,0,0.3,0 c0.2,0,0.4-0.1,0.4-0.4c0.1-0.5,0-0.9-0.4-1.1c-0.4-0.2-0.8-0.4-1.3-0.5c-0.3-0.1-0.5,0.1-0.5,0.4C19.2,38.2,19.8,38.9,20.8,38.9 L20.8,38.9z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M24,0C14.8,0,7.4,7.5,7.4,16.6v2.5h11.1v-2.5c0-3.1,2.5-5.5,5.5-5.5s5.5,2.5,5.5,5.5v2.5h11.1v-2.5 C40.6,7.5,33.2,0,24,0z"
});

function SvgPrivacyIconGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 64,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 64",
    style: {
      enableBackground: "new 0 0 48 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", null, _ref4, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref5), _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyIconGreen);
export default __webpack_public_path__ + "static/media/privacyIcon-green.18b48044274b6b4d226b23636ec2101b.svg";
export { ForwardRef as ReactComponent };